Page404Tmpl = require('./tmpl/page404.hbs')

class Page404 extends Marionette.ItemView
    template: Page404Tmpl

module.exports = Page404